// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-routes-App-components-LoginPrompt-login-prompt__container--2-6HV{display:flex;width:100%;justify-content:center;align-items:center;padding:20px;flex:1}.src-routes-App-components-LoginPrompt-login-prompt__prompt--R__Xk{text-align:center;color:#d8dadc}.src-routes-App-components-LoginPrompt-login-prompt__title--1Xrme{font-size:18px;font-weight:500;margin-bottom:8px}.src-routes-App-components-LoginPrompt-login-prompt__message--2W-vA{font-size:14px;margin-bottom:12px}\n", ""]);
// Exports
exports.locals = {
	"container": "src-routes-App-components-LoginPrompt-login-prompt__container--2-6HV",
	"prompt": "src-routes-App-components-LoginPrompt-login-prompt__prompt--R__Xk",
	"title": "src-routes-App-components-LoginPrompt-login-prompt__title--1Xrme",
	"message": "src-routes-App-components-LoginPrompt-login-prompt__message--2W-vA"
};
module.exports = exports;
